/**
 * Ordering gate (storefront UX).
 *
 * A product whose pricing is gated renders a `.price__login-link` instead of a
 * price (see snippets/price.liquid). For those products this disables ordering:
 * the add-to-cart button is disabled so a blocked user cannot add to cart, and
 * express/dynamic checkout buttons are hidden. The "choose options" control is
 * left untouched so the quick-view drawer still opens with product information
 * (the add-to-cart inside that drawer is disabled the same way once rendered).
 *
 * Keying off the rendered login link means this mirrors the server-side price
 * gate per product — same scope (all vs tagged), every surface (PDP, cards,
 * quick-add, quick-view, featured). The Switchboard cart rule is the real
 * enforcement; this just keeps the UI from letting a blocked user add to cart.
 */
(function () {
  // Nearest product boundary for a control, so we test THIS product's price, not a neighbour's.
  // quick-add-drawer is included because it shows one product but splits the price
  // (body) and the add-to-cart (footer) into sibling subtrees.
  var BOX = 'product-card, .card--product, .product-info, .quick-add-info, .featured-product, quick-add-drawer';
  var ADD = 'button[name="add"]';
  var EXPRESS = '.product-info__dynamic-checkout-btn, shopify-payment-button, [data-shopify="payment-button"]';

  function gatedBox(el) {
    var box = el.closest(BOX);
    return box && box.querySelector('.price__login-link') ? box : null;
  }

  function apply(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll(ADD).forEach(function (btn) {
      if (btn.__wsGated) return;
      var box = gatedBox(btn);
      if (!box) return;
      btn.__wsGated = true;
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');

      // Relabel to the "log in to order" prompt carried on the login link.
      var link = box.querySelector('.price__login-link');
      var label = link && link.getAttribute('data-order-label');
      if (label) {
        var textEl = btn.querySelector('.quick-add-btn-text') || btn;
        textEl.textContent = label;
      }
    });
    root.querySelectorAll(EXPRESS).forEach(function (ex) {
      if (gatedBox(ex)) ex.style.display = 'none';
    });
  }

  apply(document);

  // Cards, quick-view and quick-add render their controls asynchronously.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) apply(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
